export enum ParkingTimeSlot {
	DAY = 'DAY',
	NIGHT = 'NIGHT',
}
